



















































import {Component} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from '@/shared/services/mixin';
import {LadingErrorStore} from "@/modules/ladingerror/store";
import {LadingErrorParams} from "@/modules/ladingerror/params";
import LadingErrorLabel from "@/shared/components/LadingErrorStatusLabel/index.vue";
import LadingErrorStatusLabel from "@/shared/components/LadingErrorStatusLabel/index.vue";
import LadingErrorTableAction from "@/modules/ladingerror/List/components/TableAction.vue";
import LadingErrorSearch from "@/modules/ladingerror/List/components/Search.vue";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import LadingErrorCreate from "@/modules/ladingerror/List/components/Create.vue";
import {LadingTargetType} from "@/enums/type/ladingtarget";
import EmployeeLabel from "@/modules/employees/List/components/Label.vue";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {LadingErrorStatus} from "@/enums/status/ladingerror";
import {LadingStatus} from "@/enums/status";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

@Component({
    name: "LadingError",
    components: {
        TooltipLabel,
        EmployeeLabel,
        LadingErrorCreate,
        LadingStatusLabel,
        LadingErrorSearch, LadingErrorTableAction, LadingErrorStatusLabel, LadingErrorLabel
    }
})
export default class extends mixins(CommonMixin) {
    LadingTargetType = LadingTargetType;
    LadingStatus = LadingStatus;
    columns = [
        {
            title: "Xử lý",
            dataIndex: "id",
            key: "action",
            scopedSlots: {customRender: "action"},
            width: 80,
            align: "center"
        },
        {
            title: "Ngày, giờ sự cố",
            dataIndex: "createdDate",
            key: "ladingCode",
            width: 150,
            ellipsis: true
        },
        {
            title: "Mã vận đơn",
            dataIndex: "billLading.ladingCode",
            width: 120,
            ellipsis: true
        },
        {
            title: "Sự cố giao",
            dataIndex: "note",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "note"}
        },
        {
            title: "KH phản hồi sự cố",
            dataIndex: "customerResponse",
            width: 200,
            ellipsis: true,
            scopedSlots: {customRender: "customerResponse"}
        },
        {
            title: "Phương án xử lý",
            dataIndex: "solution",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "solution"}
        },
        {
            title: "Mã khách hàng",
            dataIndex: "billLading.customer.customerCode",
            width: 150,
            ellipsis: true
        },
        {
            title: "Tuyến phát",
            dataIndex: "billLading.holdEmployee",
            width: 250,
            scopedSlots: {customRender: "holdEmployee"},
            ellipsis: true
        },
        {
            title: "Vận đơn đối tác",
            dataIndex: "billLading.partnerLadingCode",
            key: "partnerLadingCode",
            width: 150,
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "billLading.status",
            key: "billLadingStatus",
            scopedSlots: {customRender: "billLadingStatus"},
            width: 150,
            ellipsis: true
        },
        {
            title: "Người lập sự cố",
            dataIndex: "createdBy.employee.fullname",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "createdName"}
        },
        {
            title: "Trạng thái xử lý",
            dataIndex: "status",
            scopedSlots: {customRender: "status"},
            width: 120,
            ellipsis: true
        },
        {
            title: "GDV xử lý",
            dataIndex: "updatedBy.employee.fullname",
            width: 150,
            ellipsis: true
        }
    ];
    
    
    get ladingErrorList() {
        return LadingErrorStore.ids.map((id: number) => LadingErrorStore.data[id])
    }
    
    get pagination() {
        return {
            current: LadingErrorStore.meta.page,
            pageSize: LadingErrorStore.meta.limit,
            total: LadingErrorStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} đơn sự cố`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }
    
    
    onChangePage(pagination: any) {
        LadingErrorStore.listLadingError({
            ...LadingErrorStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        });
    }
    
    created() {
        LadingErrorStore.listLadingError({...new LadingErrorParams(), status: LadingErrorStatus.ChoXuLy})
    }
}
